import { render, staticRenderFns } from "./IcoBuildingClock.vue?vue&type=template&id=00354b72"
import script from "./IcoBuildingClock.vue?vue&type=script&lang=js"
export * from "./IcoBuildingClock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports